<template>
	<div class="fd-form-columns" :style="flexStyle" :class="clazz" v-if="visible">
		<template v-for="item in part.items">
			<component :is="componentOfPart(item)" :part="partRef(item)" :data="localData" :readonly="ro" :viewmode="vm"></component>
		</template>
	</div>
</template>

<script setup lang="ts">
import useContainer, { type ContainerProps, containerProps } from "./Container";
import {computed, defineProps} from "vue";
import type { Columns } from "@t/fd/layout/Columns";

const uprops = defineProps({
  ...containerProps,
});
const props = uprops as ContainerProps;

const part = computed<Columns>(() => props.part as Columns);

const { componentOfPart, partRef, localData, ro, vm, visible, style, clazz } = useContainer(props);

const flexStyle = computed(() => {
  const styles = [{
    justifyContent: part.value.justify ? part.value.justify : "flex-start",
    alignItems: part.value.align ? part.value.align : "flex-start",
  }, style.value];
  if (part.value.space) {
    styles.push({ columnGap: part.value.space });
  }
  return styles;
});
</script>

<style>
.fd-form-columns {
	display: flex;
	flex-direction: row;
	column-gap: var(--form-h-gap);
}
</style>
